import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "rail-container" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "btn-icon" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "btn-label" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ActionRail',
    props: {
        actions: {},
        activeId: { default: undefined },
        customClass: { default: '' }
    },
    emits: ["action"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const handleAction = (id) => {
            emit('action', id);
        };
        const getNodeIcon = (action) => {
            return action.icon ?? action.iconSvg;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["bottom-action-rail", __props.customClass])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: action.id,
                            class: _normalizeClass(["action-btn", { 'is-active': __props.activeId === action.id }]),
                            onClick: ($event) => (handleAction(action.id))
                        }, [
                            _createElementVNode("span", _hoisted_3, [
                                _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
                                (typeof getNodeIcon(action) === 'string')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        innerHTML: getNodeIcon(action)
                                    }, null, 8 /* PROPS */, _hoisted_4))
                                    : (getNodeIcon(action))
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(getNodeIcon(action)), { key: 1 }))
                                        : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(action.label), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_2));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ], 2 /* CLASS */));
        };
    }
});
